<template>
    <div>
        <div class="modal fade" id="selectLangModal" tabindex="-1" role="dialog" aria-labelledby="selectLangModal"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered popup-main-2" role="document">
                <div class="modal-content box-shadow-main">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <h3 class="popup-title mb-20">{{ $t('choose_language') }}</h3>
                    <div class="select-lang">
                        <div class="select-lang-item" :class="{ active: locate == localize.lang }"
                            @click="setLocate(localize)" v-for="(localize, index) in configs.localize">
                            <div class="lang-icon">
                                <img :src="localize.img_flag" alt="">
                            </div>
                            <div class="lang-text">
                                {{ $t(localize.lang) }}
                            </div>
                            <div class="lang-checked" v-if="locate == localize.lang">
                                <i class="ito-icon-checked-white"></i>
                            </div>
                        </div>

                    </div>
                    <div class="ito-btn-large mt-20" @click="updateLocate()"
                        style="width: auto; padding: 9px 40px; margin: 8px auto 0 auto;line-height: inherit;">
                        {{ $t('confirm') }}
                    </div>
                </div>
            </div>
        </div>
        <div id="event-wrapper">
            <nav-bar-auth />

            <div id="content-event">
                <div class="container">
                    <div class="event-alert">
                        <p>{{ $t('mkt_topbanner1') }}</p>
                    </div>
                </div>
                <router-view></router-view>
            </div>
        </div>
        <div class="loading" id="loading" v-if="isLoading">
            <img class="spinner" src="/themes/ito/images/loadding.png" alt="" />
        </div>

    </div>
</template>

<script>
import SideBar from "../SideBar";
import FooterElement from "../FooterElement";
import NavBarAuth from "../NavBarAuthEvent";
import { getConfigs, getLanguage, soundClick } from "../../utils/utils";
import { updateLanguage } from '../../models/profile';

export default {
    name: "AuthLayoutEvent",
    data() {
        const grade_default = localStorage.getItem('grade');
        //const configs = getConfigs();
        //const localizes = configs.localize || [];

        const configs = this.$store.getters.configs;

        return {
            locate: getLanguage(),
            locate_obj: null,
            user: {
                grade: 1
            },
            grade_selected: grade_default || 1,
            placement_test: {
                id: 0,
                condition_pass: 0,
                time: 0,
                total_question: 0,
            },
            // configs: configs,
            // localizes: localizes,
            localizes: configs ? configs.localize : [],

        };
    },

    components: {
        NavBarAuth,
        FooterElement,
        SideBar
    },

    computed: {
        isLoading() {
            return this.$store.getters.isLoading
        },
        configs() {
            const configs = this.$store.getters.configs;
            if (configs) {
                return configs;
            }

            return {
                localize: []
            }
        },
    },

    methods: {
        getSoundClick() {
            soundClick();
        },

        setLocate(e) {
            this.getSoundClick();
            this.locate_obj = e;
            this.locate = e.lang;
        },

        updateLocate() {
            const that = this;
            this.getSoundClick();
            localStorage.setItem('lang', this.locate);
            if (that.locate_obj != null) {
                window.location.reload();
            }
        },
    }

}
</script>
<style scoped>
#event-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    position: relative;
    background-image: url(/public/themes/ito/images/background-login-chrismas.png);
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    -moz-background-size: cover;
    -ms-background-size: cover;
    background-attachment: fixed;
    background-position: bottom center;
    overflow: hidden;
}

#content-event {
    position: relative;
    width: 100%;
    padding: 30px;
    text-align: justify;
    padding-bottom: 100px;
}


.event-alert {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: -30px auto 10px auto;
    width: 591px;
    height: 62px;
    flex-shrink: 0;
    border-radius: 16px;
    background: #FFF;
    box-shadow: 0px 4px 0px 0px rgba(231, 231, 231, 0.25) inset, 4px 4px 0px 0px rgba(0, 0, 0, 0.07);
}

.event-alert p {
    color: #E74715;
    text-align: center;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding-left: 93px;
    padding-right: 93px;
}
</style>